import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

// import Google from '../../assets/icons/Google';
import InputField from "../../components/InputField/InpurField";
import { PasswordField } from "../../components/PasswordField/PasswordField";
import withoutAuth from "../../services/withoutAuthProvider";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Form, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import decodeJwtResponse from "jwt-decode";
import { validatePassword } from "../../utils/string";
import SyaratKetentuan from "../../components/Modals/SyaratKetentuan";

const CHECKBOX_STYLE = { width: "1.1rem", height: "1.1rem" };

const SignUp = () => {
  const { push } = useHistory();
  const google = window.google;

  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [statusValidation, setStatusValidation] = useState(null);
  const [showTncModal, setShowTncModal] = useState(false);

  // form validation rules
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .transform((x) => (x === "" ? undefined : x))
      .concat(Yup.string().required("Silahkan mengisi nama lengkap")),
    email: Yup.string()
      .transform((x) => (x === "" ? undefined : x))
      .concat(Yup.string().required("Silahkan mengisi email")),
    password: Yup.string()
      .transform((x) => (x === "" ? undefined : x))
      .concat(Yup.string().required("Silahkan mengisi kata sandi"))
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
        "Kata Sandi harus memiliki minimal 8 karakter, terdapat huruf besar dan kecil serta mengandung angka"
      )
      .min(8, "Kata sandi harus minimal 8 karakter"),
    password_confirmation: Yup.string()
      .transform((x) => (x === "" ? undefined : x))
      .when("password", (password, schema) => {
        if (password) return schema.required("Silahkan mengisi konfirmasi kata sandi");
      })
      .oneOf([Yup.ref("password")], "Kata sandi harus sama"),
    is_agree: Yup.bool().oneOf([true], "Wajib menyetujui syarat dan ketentuan"),
    is_agree_privacy: Yup.bool().oneOf([true], "Wajib menyetujui kebijakan privasi"),
  });

  // functions to build form returned by useForm() hook
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { is_agree: false, is_agree_privacy: false },
  });

  const handleClick = (path) => {
    push(path);
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();

    const dataUser = new FormData();
    dataUser.append("name", data.name);
    dataUser.append("email", data.email);
    dataUser.append("password", data.password);
    dataUser.append("password_confirmation", data.password_confirmation);

    setLoadingRegister(true);
    const loading = toast.loading("Mengirimkan...");
    const response = await withoutAuth.postDataWithoutAuth("/api/register", dataUser);
    if (response?.status === 200) {
      toast.dismiss(loading);
      toast.success(response.data.message, {
        id: "success-message",
        duration: 3000,
      });
      setLoadingRegister(false);
      reset({
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
      });
      push("/masuk");
    } else {
      toast.dismiss(loading);

      // Handle error dengan struktur errors.details
      if (response?.data?.errors?.details) {
        toast.error(response.data.errors.details, {
          id: "error-message",
          duration: 3000,
        });
      }
      // Handle error dengan struktur message sebagai object
      else if (
        typeof response.data.message === "object" &&
        response.data.message !== null &&
        !Array.isArray(response.data.message)
      ) {
        var data_message = "";
        for (var key in response.data.message) {
          if (response.data.message.hasOwnProperty(key)) {
            data_message += response.data.message[key];
          }
        }

        toast.error(data_message, {
          id: "error-message",
          duration: 3000,
        });
      }
      // Handle error dengan struktur message sebagai string
      else {
        toast.error(response.data.message || "Terjadi kesalahan", {
          id: "error-message",
          duration: 3000,
        });
      }

      setLoadingRegister(false);
    }

    e.target.reset();
  };

  const responseGoogle = async (response) => {
    const responsePayload = decodeJwtResponse(response.credential);

    const dataUser = {
      id: responsePayload.sub,
      email: responsePayload.email,
      full_name: responsePayload.name,
    };

    setLoadingGoogle(true);
    const loading = toast.loading("Mengirimkan...");
    const responseAPI = await withoutAuth.postDataWithoutAuth("/api/register/social/google", dataUser);
    if (responseAPI.status === 200) {
      toast.dismiss(loading);
      toast.success(responseAPI.data.message, {
        id: "success-message",
        duration: 3000,
      });
      setLoadingGoogle(false);
      push("/masuk");
    } else {
      toast.dismiss(loading);
      toast.error(responseAPI?.data?.message?.email, {
        id: "error-message",
        duration: 3000,
      });
      setLoadingGoogle(false);
    }
    google.accounts.id.disableAutoSelect();
  };

  useEffect(() => {
    google?.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: responseGoogle,
    });
    google?.accounts.id.renderButton(
      document.getElementById("hiddenGoogleButton"),
      { theme: "outline", size: "medium", text: "signup_with" } // customization attributes
    );
  }, []);

  const handleGoogleRegister = () => {
    setShowTncModal(true);
  };

  const handleConfirmTnc = () => {
    setShowTncModal(false);
    const hiddenButton = document.querySelector("#hiddenGoogleButton div[role='button']");
    if (hiddenButton) {
      hiddenButton.click();
    }
  };

  return (
    <div className="w-100">
      <p className="fw-bold fs-4 mb-2">Daftar</p>
      <div className="font-sm d-flex mb-3">
        <div className="me-2 text-secondary">Sudah punya akun?</div>
        <div className="text-primary cursor-pointer" onClick={() => handleClick("/masuk")}>
          Masuk
        </div>
      </div>
      <div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <Controller
              control={control}
              name="name"
              render={({ field: { onChange, name, value } }) => (
                <InputField
                  id="fullName"
                  placeholder="Masukan Nama Lengkap Anda"
                  onChange={onChange}
                  label="Nama Lengkap"
                  type="text"
                  name={name}
                  value={value}
                />
              )}
            />
            {errors.name?.message && <span className="error-message">{errors.name?.message}</span>}
            <Controller
              control={control}
              name="email"
              render={({ field: { onChange, name, value } }) => (
                <InputField
                  id="email"
                  placeholder="Masukan Email Anda"
                  onChange={onChange}
                  label="Email"
                  type="email"
                  autoComplete="off"
                  name={name}
                  value={value}
                />
              )}
            />
            {errors.email?.message && <span className="error-message">{errors.email?.message}</span>}
            <Controller
              control={control}
              name="password"
              render={({ field: { onChange, name, value } }) => (
                <PasswordField
                  validation={statusValidation}
                  id="password"
                  placeholder="Masukan Kata Sandi"
                  onChange={(val) => {
                    setStatusValidation(validatePassword(val?.target?.value));
                    onChange(val);
                  }}
                  label="Kata Sandi"
                  name={name}
                  value={value}
                  extended
                />
              )}
            />
            {errors.password?.message && <span className="error-message">{errors.password?.message}</span>}
            <Controller
              control={control}
              name="password_confirmation"
              render={({ field: { onChange, name, value } }) => (
                <PasswordField
                  id="password2"
                  placeholder="Masukan Konfirmasi Kata Sandi"
                  onChange={onChange}
                  label="Konfirmasi Kata Sandi"
                  name={name}
                  value={value}
                />
              )}
            />
            {errors.password_confirmation?.message && (
              <span className="error-message">{errors.password_confirmation?.message}</span>
            )}
            <Controller
              control={control}
              name="is_agree"
              render={({ field: { onChange, name, value } }) => (
                <div className="d-flex mt-3 font-sm justify-content-between">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="disabledFieldsetCheck"
                      name={name}
                      value={value}
                      onChange={onChange}
                      style={CHECKBOX_STYLE}
                    />
                    <label className="ms-2" htmlFor="disabledFieldsetCheck">
                      Saya Menyetujui{" "}
                      <a href="/syarat-dan-ketentuan" className="fw-bold text-primary">
                        Syarat & Ketentuan
                      </a>{" "}
                      dari Caready
                    </label>
                  </div>
                </div>
              )}
            />
            {errors.is_agree?.message && <span className="error-message">{errors.is_agree?.message}</span>}
            <Controller
              control={control}
              name="is_agree_privacy"
              render={({ field: { onChange, name, value } }) => (
                <div className="d-flex mt-2 font-sm justify-content-between">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="privacyFieldsetCheck"
                      name={name}
                      value={value}
                      onChange={onChange}
                      style={CHECKBOX_STYLE}
                    />
                    <label className="ms-2" htmlFor="privacyFieldsetCheck">
                      Saya Menyetujui{" "}
                      <a href="/kebijakan-privasi" className="fw-bold text-primary">
                        Kebijakan Privasi
                      </a>{" "}
                      dari Caready
                    </label>
                  </div>
                </div>
              )}
            />
            {errors.is_agree_privacy?.message && <span className="error-message">{errors.is_agree_privacy?.message}</span>}
          </div>
          <div className="d-grid gap-2">
            <button className="btn btn-primary font-sm" type="submit" disabled={loadingRegister}>
              {loadingRegister ? <Spinner animation="border" size="sm" /> : ""}
              Daftar
            </button>
          </div>
        </Form>
        <div className="text-center">
          <div className="font-sm text-secondary my-3 has-line">atau daftar dengan</div>
          <div className="row">
            <div className="col-12">
              {/* Hidden Google button for programmatic trigger */}
              <div id="hiddenGoogleButton" style={{ display: "none" }}></div>
              <div className="d-grid gap-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary d-flex align-items-center justify-content-center google-signin-button font-sm"
                  onClick={handleGoogleRegister}
                  disabled={loadingGoogle}
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #dadce0",
                    color: "#3c4043",
                    fontWeight: 500,
                    minHeight: "40px",
                  }}
                >
                  {loadingGoogle ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <>
                      <svg width="18" height="18" viewBox="0 0 18 18" style={{ marginRight: "12px" }}>
                        <path
                          fill="#4285F4"
                          d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
                        />
                        <path
                          fill="#34A853"
                          d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"
                        />
                        <path
                          fill="#FBBC05"
                          d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707 0-.593.102-1.17.282-1.709V4.958H.957C.347 6.173 0 7.548 0 9c0 1.452.348 2.827.957 4.042l3.007-2.335z"
                        />
                        <path
                          fill="#EA4335"
                          d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
                        />
                      </svg>
                      Daftar dengan Google
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showTncModal && (
        <SyaratKetentuan
          onCancel={() => setShowTncModal(false)}
          onConfirm={handleConfirmTnc}
        />
      )}
    </div>
  );
};

export default SignUp;
